/* import __COLOCATED_TEMPLATE__ from './fin-global-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type RouterService from '@ember/routing/router-service';

interface Args {}

export default class FinGlobalBanner extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare intercomEventService: $TSFixMe;
  @service declare router: RouterService;

  get location(): string {
    return this.router.currentRouteName || '';
  }

  @action
  onCtaClick() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'fin_global_banner_cta',
      place: this.location,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'IncentiveOffer::Banners::FinGlobalBanner': typeof FinGlobalBanner;
    'incentive-offer/banners/fin-global-banner': typeof FinGlobalBanner;
  }
}
